import { externalTranslationApi } from '@/api/externalTranslationApi'

export class externalTranslationLogService {
    async getTranslationLogs() {
        return await externalTranslationApi.getTranslationLogs();
    }
}